import { useEffect, useState } from "react";

import type { AuthClient } from "@nav-games/auth-client";

interface Props {
  auth: AuthClient;
  onDone: (to: string) => void;
}

/// Consumes the URL-fragment handoff goastern-auth leaves at
/// `<returnUrl>#access=…&refresh=…&expires=…&audience=…`. Saves the
/// session, scrubs the fragment from the address bar, then navigates
/// to /play so the user lands in the games tree (the account page is
/// reachable from the header for users who want it).
export function AuthCallback({ auth, onDone }: Props) {
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const session = auth.consumeCallback();
    if (!session) {
      setError("No sign-in tokens found in the URL.");
      return;
    }
    // Replace the URL so the fragment doesn't sit in history.
    window.history.replaceState({}, "", "/play");
    onDone("/play");
  }, [auth, onDone]);

  if (error) {
    return (
      <div className="card">
        <h2>Sign-in failed</h2>
        <p className="muted">{error}</p>
        <p>
          <a href="/">Back to the home page</a>
        </p>
      </div>
    );
  }
  return (
    <div className="card">
      <h2>Signing you in…</h2>
      <p className="muted">One moment.</p>
    </div>
  );
}
